import React, { Component } from 'react';
import { IReducerState } from '../../../states/renditionStates';
import { connect } from 'react-redux';
import { RenditionLoadable } from '../../../utils/general/LoadableRelated';
import * as HTML_RENDITION from '../../../utils/general/general';
import * as asyncStateAction from '../../../actions/asyncStateAction';
import servicesConfig from '../../../services/servicesConfig';
import $ from 'jquery';
import _ from 'lodash';
import { switchPage } from '../../../utils/api/pageControl';
import commonStore from '../../../store/commonStore.js';
import Loading from '../../../utils/animation/loading';
import { enterKeyPressed } from '../../../utils/general/enterKey';
import { RSCH_HTML_TRACKING_CONFIG } from '../../../readership/trackingConfig';
import RenditionUrlGenerator from '../../../utils/api/renditionUrlGenerator';

const ModalPopup = RenditionLoadable({
    loader: () => import('../../../modalrelated/modalPopup'),
}, "modalPopup", Date.now());

const NormalScreenPopup = RenditionLoadable({
    loader: () => import('../../../modalrelated/normalScreenPopup'),
}, "normalScreenPopup", Date.now());

interface IMultiCompanyBullBearProps {
    source?: any;
    docHeaderSectionJson: any;
    initialData: any;
    multiCompanyMetaData: any;
    flipVersionData: any;
    originFlipVersionData: any;
    htmlPDFtoggleStatus: boolean;
    checkOriginFlipVerisonDoc: (_originDocRequestPara: any, _originDocId: any) => {};
}

interface IMultiCompanyBullBearStatus {
    modalStatus: boolean;
}

const originDocRequestPara: any = servicesConfig.GET_ORIGIN_FLIP_VERISON_DOC;
let originDocId: string | number = '';

export class MultiCompanyBullBear extends Component<IMultiCompanyBullBearProps, IMultiCompanyBullBearStatus> {
    public currentData: any;
    public ifShowOriginLink: boolean;
    public bullBearJumpId: any;
    public originDocUrl: any;

    constructor(props: IMultiCompanyBullBearProps) {
        super(props);
        this.ifShowOriginLink = false;
        this.bullBearJumpId = '';
        this.originDocUrl = null;
        this.state = {
            modalStatus: false,
        };
    }

    public isShowOriginLinkFun() {
        const { docHeaderSectionJson } = this.props;
        return docHeaderSectionJson.bullBearChart[this.currentData].isOriginDoc == 'false' && this.ifShowOriginLink;
    }

    public openOriginLinkHrefFun(e: any) {
        e.preventDefault();
        const { docHeaderSectionJson } = this.props;
        let originDocUrlLink = this.originDocUrl;
        if (_.isEmpty(originDocUrlLink)) {
            originDocUrlLink = docHeaderSectionJson.bullBearChart[this.currentData].originDocUrl;
        }

        if (HTML_RENDITION.isBloomBerg()) {
            HTML_RENDITION.checkDocIdAndOpenPubicationForBBGWithDocumentURL(originDocUrlLink, true);
            return;
        }
        if (HTML_RENDITION.isThirdPartyTokenAuthorization()) {
            HTML_RENDITION.executeWindowOpenForEPFToken(originDocUrlLink);
            return;
        }

        window.open(originDocUrlLink, HTML_RENDITION.isAppInsideCVResearchUIiFrame() ? '_self' : '_blank');
    }

    public shouldComponentUpdate(nextProps: IMultiCompanyBullBearProps, nextState: any) {
        if (!_.isNull(this.props.multiCompanyMetaData) &&
            !_.isUndefined(this.props.multiCompanyMetaData) &&
            !_.isUndefined(nextProps.multiCompanyMetaData)) {
            if ((this.props.multiCompanyMetaData.companyCode == nextProps.multiCompanyMetaData.companyCode)) {
                return true;
            }
            return false;
        }
        return false;
    }

    public openModal(e: any) {
        // Important!!! the close modal action can through bubbling propagation to here, So that we can set the status again!
        // Improtant!!! you must setState in below if else to avoid cause reRender!
        if (e.target.id === "modalClose" || e.target.className === 'bb_scrollToLink') { // Improtant!!! if you want close modal in more case only change this if
            this.setState({
                modalStatus: false,
            });
            $('.triggered_popup_flag').focus().removeClass('triggered_popup_flag');
        } else if (this.state.modalStatus === false) { // Improtant!!! don't change this if in any case
            setTimeout(() => {
                this.getBullBearChart();
                this.setState({
                    modalStatus: true,
                });
            }, 500);
            e.target.className += " triggered_popup_flag";
            RSCH_HTML_TRACKING_CONFIG.trackRequestBullBearClick();
        }
    }

    public getBullBearChart() {
        const { multiCompanyMetaData, docHeaderSectionJson, flipVersionData } = this.props;
        // The data in multicompany and other companys is diff so need diff logic,also in multicompany need get new url each time(because the company title may change across user select)
        // Not need check isMulticompany like old rendition anymore(I have write all case in parent component to check if import this chlidren compenent).
        this.ifShowOriginLink = false;
        const flipVersionId = flipVersionData?.flipVersionId?.split("=")[0];
        const companyTitleTotal = $(".multicompany-dropdown-container .dropdown-menu a");
        const currentTitleName = $(".multicompany-dropdown-container #multiCompanyDropdown").text();
        const companyTitleLength = companyTitleTotal.length;
        let currentIndex: number = 0;
        for (let companyTitle = 0; companyTitle < companyTitleLength; companyTitle++) {
            if (companyTitleTotal.eq(companyTitle).text() == currentTitleName) {
                currentIndex = companyTitle;
                break;
            }
        }
        // Important!!! This currentTitleCode is diff with old rendition,but I think old currentTitleCode is wrong, but still ensure the currentTitleCode in future!
        const currentTitleCode: any = multiCompanyMetaData.companyCode;
        const bullBearChart = docHeaderSectionJson.bullBearChart;
        for (const item in bullBearChart) {
            if (item.indexOf(currentTitleCode) >= 0) {
                this.currentData = item;
                break;
            }
        }
        this.originDocUrl = bullBearChart[this.currentData].originDocUrl;
        if (this.originDocUrl) {
            if (this.originDocUrl.indexOf(flipVersionId) != '-1' && flipVersionData.flipVersionId != "") {
                this.ifShowOriginLink = false;
            } else {
                this.ifShowOriginLink = true;
            }
        }
        if ($('.multiCompanySmallTitle').eq(currentIndex).parent('div.row').find('.BullBearPage img').length > 0 && docHeaderSectionJson.bullBearChart[this.currentData].isOriginDoc == 'true') {
            this.ifShowOriginLink = false;
            return;
        } else {
            this.ifShowOriginLink = true;
        }
        const tmpOriginDocUrl = this.originDocUrl;
        const _originDocId = tmpOriginDocUrl ? tmpOriginDocUrl.split("/") : '';
        this.getNewUrl(_originDocId);
    }

    public getNewUrl(_originDocId: any) {
        const { originFlipVersionData } = this.props;
        if (_.isEmpty(originFlipVersionData)) {
            return false;
        }
        _originDocId = Base64.decode(_originDocId[_originDocId.length - 1]);
        _originDocId = _originDocId.split("=");
        _originDocId = parseInt(_originDocId[1], 10);
        originDocId = _originDocId;
        const _url_parameter = {
            url_parameter: [
                'doc_id=' + _originDocId,
            ]
        };
        if (!originFlipVersionData[_originDocId]) {
            Object.assign(originDocRequestPara, _url_parameter);
            this.props.checkOriginFlipVerisonDoc(originDocRequestPara, _originDocId);
        }
    }

    public getModalSource() {
        const { multiCompanyMetaData, docHeaderSectionJson } = this.props;
        let bullBaerInnerDOM: any = null;
        let currentCompanyBullBearImgsFlag = false;
        const companyCode = multiCompanyMetaData.companyCode;
        let template: any = null;
        let currentBBSeq = 0;

        // Check whether current company has BB in main page.
        const companySectionIndicators = $('.companyCode');
        let $bullBearTable = null;
        if (window.HTML_RENDITION.initialData.isFAVE) {
            const bullBearContainerIndicator = '.bullBear_' + (companyCode.indexOf('.') > -1 ? companyCode.split('.').join('_') : companyCode);
            const $bullBearContainer = $(bullBearContainerIndicator).nextAll('.citiTable-template-part').eq(0); // get the first table after the bullBear_companyCode
            if ($bullBearContainer.find('table.BullBearPage').length > 0) {
                currentCompanyBullBearImgsFlag = true;
                $bullBearTable = $bullBearContainer.find('table.BullBearPage');
            }
        } else {
            for (let i = 0; i < companySectionIndicators.length; i++) {
                if (companySectionIndicators[i].innerText == companyCode) {
                    if (companySectionIndicators.eq(i).parent('.row').find('table.BullBearPage').length > 0) {
                        currentCompanyBullBearImgsFlag = true;
                        currentBBSeq = i;
                    }
                    break;
                }
            }
        }
        let _bullBearJumpId = '';
        if (currentCompanyBullBearImgsFlag && !window.HTML_RENDITION.initialData.isFAVE) {
            const BBHolderTable = companySectionIndicators.eq(currentBBSeq).parent('.row').find('table.BullBearPage');
            const BBImgs = BBHolderTable.find('img');
            template = BBImgs[0].outerHTML + BBImgs[1].outerHTML;
            this.bullBearJumpId = BBHolderTable.attr('id');
            _bullBearJumpId = this.bullBearJumpId;
            template = template.replace(/documentsImages/g, 'images');
            bullBaerInnerDOM = <div dangerouslySetInnerHTML={{ __html: template }} />;
        } else if (currentCompanyBullBearImgsFlag && window.HTML_RENDITION.initialData.isFAVE && $bullBearTable) {
            const $bullBearImgs = $bullBearTable.find('img');
            template = $bullBearImgs.eq(0).prop("outerHTML") + $bullBearImgs.eq(1).prop("outerHTML");
            this.bullBearJumpId = $bullBearTable.attr('id');
            _bullBearJumpId = this.bullBearJumpId;
            template = template.replace(/documentsImages/g, 'images');
            bullBaerInnerDOM = <div dangerouslySetInnerHTML={{ __html: template }} />;
        } else {
            template =
                <div id="bull-bear-body">
                    <img className="bullbear-chart-img" width="100%" src={docHeaderSectionJson.bullBearChart[companyCode].chartUrl} alt={HTML_RENDITION.buildAdaAltText(docHeaderSectionJson.i18n.bullBearScenarios + '. ', companyCode + 'chart image.')} />
                    <img className="bullbear-table-img" width="100%" src={docHeaderSectionJson.bullBearChart[companyCode].tableUrl} alt={HTML_RENDITION.buildAdaAltText(docHeaderSectionJson.i18n.bullBearScenarios + '. ', companyCode + 'table image.')} />
                </div>;
            bullBaerInnerDOM = template;
        }
        const bullBearOuterDOM =
            <div id="bull-bear-popup-content">
                {this.isShowOriginLinkFun() &&
                    <div className="bb_view_original_doc">
                          <a tabIndex={0} role="link"
                             aria-label={docHeaderSectionJson.i18n.original_link}
                             onClick={(e) => this.openOriginLinkHrefFun(e)}
                             onKeyPress={(e) => enterKeyPressed(e, this.openOriginLinkHrefFun.bind(this))}
                        >{docHeaderSectionJson.i18n.original_link}</a>
                    </div>
                }
                <div id="popup_bullbear">
                    {bullBaerInnerDOM}
                </div>
                {currentCompanyBullBearImgsFlag &&
                    <div className={currentCompanyBullBearImgsFlag ? "bb_scrollToLink_holder" : "hide"} style={{ display: 'block' }}>
                        <span>{docHeaderSectionJson.i18n.figure_here_before} </span>
                        <a tabIndex={currentCompanyBullBearImgsFlag ? 0 : -1} role="link" aria-label={docHeaderSectionJson.i18n.figure_here} className="bb_scrollToLink"
                         onClick={(e) => this.scrollToCompBullBear(e, _bullBearJumpId)}
                         onKeyPress={(e) => enterKeyPressed(e, this.scrollToCompBullBear.bind(this, e, _bullBearJumpId))}
                         >{docHeaderSectionJson.i18n.figure_here} </a>
                        <span>{docHeaderSectionJson.i18n.figure_here_after}</span>
                    </div>
                }
            </div>;
        return bullBearOuterDOM;
    }

    public scrollToCompBullBear(e: any, bullBearJumpId: any) {
        // Important!!! Don't use react-redux mapStateToProps to get switchPageData in this file! Because when switchPageData change, it will cause reRender!
        const _pageName = commonStore.getState().commonStateReducer.switchPageData.pageName;
        if (_pageName !== 'mainPage') {
            switchPage('TocToMainPage');
        }
        if (this.props.initialData.showPDFDigidocViewer) {
            HTML_RENDITION.toggleToShowHTML(this.props.htmlPDFtoggleStatus);
        }
        HTML_RENDITION.bodyScrollTo(bullBearJumpId);
    }

    public render() {
        const { docHeaderSectionJson, originFlipVersionData } = this.props;
        const _modalStatus = this.state.modalStatus;
        let _modalSource = null;
        const lan = docHeaderSectionJson.metadata.isJP ? 'ja' : 'EN';

        if (this.currentData && docHeaderSectionJson.bullBearChart[this.currentData].isOriginDoc == 'false') {
            if (!_.isEmpty(originFlipVersionData) && originFlipVersionData[originDocId] && lan == originFlipVersionData[originDocId].lang && this.ifShowOriginLink) {
                const smallurl = docHeaderSectionJson.bullBearChart[this.currentData].originDocUrl.split('/');
                smallurl[smallurl.length - 1] = originFlipVersionData[originDocId].flipVersionId;
                const newUrl = smallurl.join('/');
                this.originDocUrl = newUrl;
            }
        }
        if (docHeaderSectionJson.bullBearChart && this.currentData) {
            _modalSource = this.getModalSource();
        }
        // adding comapny23 bullbear popup url
        const isJP = docHeaderSectionJson.metadata.isJP;
        const environment = window.HTML_RENDITION.initialData.environment;
        let ticker = docHeaderSectionJson.metadata.ticker;
        if (window.HTML_RENDITION.isMCN) {
          if (!_.isEmpty(this.props.multiCompanyMetaData)) {
            ticker = this.props.multiCompanyMetaData.ticker;
          }
        }
        const bullBearUrl =
          RenditionUrlGenerator.URL_GENERATOR.environments(environment) +
          `/directory/eppublic/company23/${ticker}/popup/bb?language=${isJP ? 'ja' : 'en'}`;

        return (
            <React.Fragment>
                <div role="link" className="bullBearChart financials" onClick={(e) => this.openModal(e)}
                     onKeyPress={(e) => enterKeyPressed(e, this.openModal.bind(this, e))}>
                    {_modalStatus && _modalSource &&
                        <ModalPopup classList={'modal-bullbear'}>
                            <NormalScreenPopup
                            titleSource={`${docHeaderSectionJson.i18n.bullBearScenarios}: ${this.props.multiCompanyMetaData.companyNameAndTicker}`} bodySource={_modalSource} modalWindowStyle={{width:'100%',height: '100%'}} iframeUrl={bullBearUrl} 
                            isBullBear={true} 
                            />
                        </ModalPopup>}
                    {/* {showOldBranding && <span className="icon-bull-bear-chart icon-sprite" role="img" aria-label={docHeaderSectionJson.i18n.bullBearScenarios} />} */}
                    <span className='icon-svg-parent'>
                            <span className="icon-svg icon-bull-bear-chart-svg" role="img" aria-label={docHeaderSectionJson.i18n.bullBearScenarios}/>
                    </span>
                    <a tabIndex={0} role="link" aria-label={docHeaderSectionJson.i18n.bullBearScenarios} id="request-Bull-Bear" className="x-rsch-hyperlink">{docHeaderSectionJson.i18n.bullBearScenarios}</a>
                </div>
                {_modalStatus && !_modalSource && window.HTML_RENDITION.initialData.showOldLoading &&
                    <Loading overrideStyle={{ position: 'fixed' }} showLoadingBackground={true} />}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
        multiCompanyMetaData: state.commonStateReducer.multiCompanyMetaData,
        flipVersionData: state.asyncStateReducer.flipVersionData,
        originFlipVersionData: state.asyncStateReducer.originFlipVersionData,
        htmlPDFtoggleStatus: state.commonStateReducer.htmlPDFtoggleStatus,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        checkOriginFlipVerisonDoc: (_originDocRequestPara: any, _originDocId: any) => dispatch(asyncStateAction.fetchOriginFlipVerisonDoc(_originDocRequestPara, _originDocId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiCompanyBullBear);
